<woa-modal-page-layout [title]="title()" [subtitle]="subtitle()" [contentText]="contentText()"
                       [translationParams]="pageLayoutTranslationParams()" [footerControlOrientation]="'vertical'">
    @if (mode() === IdentificationMode.LOGIN && loginErrorKey()) {
        <woa-content-message [level]="MessageLevel.ERROR"
                             [text]="loginErrorKey()" [translationParams]="loginErrorParams()">
            @if (configurationModel.supportsRegistration()) {
                <woa-link [link]="'woa.button.identification.error.register'"
                          [postscript]="'woa.label.identification.retryError'"
                          [plain]="true"
                          (onActivate)="mode.set(IdentificationMode.REGISTER)"></woa-link>
            }
        </woa-content-message>
    }
    @if (mode() === IdentificationMode.LOGIN && registeredIdentity()) {
        <woa-content-message [level]="MessageLevel.INFO" [text]="alreadyRegisteredMessageText()"
                             [translationParams]="{'registeredIdentity': registeredIdentity(), 'otherApp': usedOtherApp()}"></woa-content-message>
    }
    @if (mode() === IdentificationMode.CONFIRM && !loadingService.loading() && confirmationFailed()) {
        <woa-content-message [level]="MessageLevel.ERROR" [text]="'woa.error.identification.loginFailed'"
                             [link]="'woa.button.common.retry'" (onLinkActivate)="confirmLogin()"></woa-content-message>
    }
    @if (mode() === IdentificationMode.REGISTER && checkRegistrationFailed()) {
        <woa-content-message [level]="MessageLevel.ERROR"
                             [text]="'woa.error.common.cannotCommunicateServer'"></woa-content-message>
    }
    @if (mode() === IdentificationMode.REGISTRATION_DETAILS && registrationFailed()) {
        <woa-content-message [level]="MessageLevel.ERROR"
                             [text]="'woa.error.identification.registrationFailed'"></woa-content-message>
    }
    @if (mode() === IdentificationMode.VERIFY_LOGIN && verificationFailed()) {
        <woa-content-message [level]="MessageLevel.ERROR"
                             [text]="'woa.error.identification.verifyRegistrationFailed'"></woa-content-message>
    }
    @if (mode() === IdentificationMode.VERIFY_REGISTRATION && verificationFailed()) {
        <woa-content-message [level]="MessageLevel.ERROR"
                             [text]="'woa.error.identification.verifyRegistrationFailed'"></woa-content-message>
    }
    @if ((mode() === IdentificationMode.ENABLE_ACCOUNT || mode() === IdentificationMode.FORGOT_PASSWORD) && requestPasswordResetFailed()) {
        <woa-content-message [level]="MessageLevel.ERROR"
                             [text]="'woa.error.identification.requestPasswordResetFailed'"></woa-content-message>
    }
    @if ((mode() === IdentificationMode.SET_PASSWORD || mode() === IdentificationMode.RESET_PASSWORD) && passwordResetFailed()) {
        <woa-content-message [level]="MessageLevel.ERROR"
                             [text]="'woa.error.identification.resetPasswordFailed'"></woa-content-message>
    }
    @if ((mode() === IdentificationMode.LOGIN || mode() === IdentificationMode.REGISTER) && accountHasNoPassword()) {
        <woa-content-message [level]="MessageLevel.ERROR"
                             [text]="'woa.error.identification.accountHasNoPassword'"></woa-content-message>
    }
    @if (mode() === IdentificationMode.LOGIN || mode() === IdentificationMode.ENABLE_ACCOUNT || mode() === IdentificationMode.FORGOT_PASSWORD) {
        <woa-form (onSubmit)="mode() === IdentificationMode.LOGIN ? login() : requestPasswordReset()">
            @if (configurationModel.loginIdentityIsEmail()) {
                <woa-email-field [(ngModel)]="email" name="email" [label]="'woa.label.common.email'"
                                 [inputId]="'login-email-field-input'"
                                 [autocomplete]="'username'" required woa-email></woa-email-field>
            }
            @if (configurationModel.loginIdentityIsMobile()) {
                <woa-phone-number-field [(ngModel)]="primaryIdentity" name="mobilePhone"
                                        [label]="'woa.label.common.mobile'"
                                        [inputId]="'login-mobilePhone-field-input'"
                                        [autocomplete]="'username'" required woa-phone-number></woa-phone-number-field>
            }
            @if (configurationModel.loginIdentityIsMemberNo()) {
                @if (configurationModel.memberNoIsNumeric()) {
                    <woa-decimal-field [(ngModel)]="primaryIdentity" name="memberNo" [label]="'woa.label.common.memberNo'"
                                       [inputId]="'login-memberNo-field-input'"
                                       [autocomplete]="'username'" [maxlength]="'25'" required></woa-decimal-field>
                } @else {
                    <woa-text-field [(ngModel)]="primaryIdentity" name="memberNo" [label]="'woa.label.common.memberNo'"
                                    [inputId]="'login-memberNo-field-input'"
                                    [autocomplete]="'username'" [spellcheck]="false" [maxlength]="'25'"
                                    required></woa-text-field>
                }
            }
            @if (mode() === IdentificationMode.LOGIN) {
                @if (configurationModel.loginRequiresSecondaryMobile()) {
                    <woa-phone-number-field [(ngModel)]="secondaryMobilePhone" name="secondaryMobilePhone"
                                            [label]="'woa.label.common.mobile'"
                                            required woa-phone-number></woa-phone-number-field>
                }
                @if (configurationModel.loginAuthenticationMethod() === AppLoginAuthenticationMethod.PASSWORD) {
                    <woa-password-field [(ngModel)]="identityPassword" name="identityPassword"
                                        [label]="'woa.label.common.password'" required [minlength]="'8'"
                                        [maxlength]="'20'"
                                        [autocomplete]="'current-password'"></woa-password-field>
                } @else if (configurationModel.loginAuthenticationMethod() === AppLoginAuthenticationMethod.DOB) {
                    <woa-date-field [(ngModel)]="identityPassword" name="identityPassword"
                                    [label]="'woa.label.common.dob'" required [autocomplete]="'off'"></woa-date-field>
                }
                <woa-field-pair>
                    <woa-selector-control [label]="'woa.label.common.rememberMe'"
                                          [(selected)]="remember"></woa-selector-control>
                    @if (configurationModel.supportsForgotPassword()) {
                        <woa-link class="forgot-password-link"
                                  [link]="'woa.button.identification.forgotPassword'"
                                  (onActivate)="mode.set(IdentificationMode.FORGOT_PASSWORD)"></woa-link>
                    }
                </woa-field-pair>
            }
        </woa-form>
    }
    @if (mode() === IdentificationMode.VERIFY_LOGIN) {
        <woa-form (onSubmit)="verifyLogin()">
            <woa-decimal-field [(ngModel)]="verificationCode" name="code"
                               [label]="'woa.label.identification.verificationCode'"
                               [autocomplete]="'one-time-code'" required [maxlength]="'50'"></woa-decimal-field>
        </woa-form>
    }
    @if (mode() === IdentificationMode.REGISTER) {
        <woa-form (onSubmit)="checkRegistration()">
            @if (configurationModel.loginIdentityIsEmail()) {
                <woa-email-field [(ngModel)]="email" name="email" [label]="'woa.label.common.email'"
                                 [inputId]="'login-email-field-input'"
                                 [autocomplete]="'username'" required woa-email></woa-email-field>
            }
            @if (configurationModel.loginIdentityIsMobile()) {
                <woa-phone-number-field [(ngModel)]="primaryIdentity" name="mobilePhone"
                                        [label]="'woa.label.common.mobile'"
                                        [inputId]="'login-mobilePhone-field-input'"
                                        [autocomplete]="'username'" required woa-phone-number></woa-phone-number-field>
            }
        </woa-form>
    }
    @if (mode() === IdentificationMode.REGISTRATION_DETAILS) {
        <woa-form (onSubmit)="register()">
            @if (configurationModel.loginIdentityIsEmail()) {
                <woa-email-field [value]="identityEntityModel.data?.email"
                                 [label]="'woa.label.common.email'" [readOnly]="true"></woa-email-field>
            }
            @if (configurationModel.loginIdentityIsMobile()) {
                <woa-phone-number-field [value]="identityEntityModel.data.mobilePhone"
                                        [label]="'woa.label.common.mobile'" [readOnly]="true"></woa-phone-number-field>
            }
            <woa-field-pair>
                <woa-text-field [(ngModel)]="identityEntityModel.data.firstName" name="firstName"
                                [label]="'woa.label.common.firstName'" required [maxlength]="'30'"
                                [autocomplete]="'given-name'" [spellcheck]="false"></woa-text-field>
                <woa-text-field [(ngModel)]="identityEntityModel.data.lastName" name="lastName"
                                [label]="'woa.label.common.lastName'" required [maxlength]="'30'"
                                [autocomplete]="'family-name'" [spellcheck]="false"></woa-text-field>
            </woa-field-pair>
            @if (!configurationModel.loginIdentityIsEmail()) {
                <woa-email-field [(ngModel)]="email" name="email"
                                 [label]="'woa.label.common.email'" required woa-email></woa-email-field>
            }
            @if (!configurationModel.loginIdentityIsMobile()) {
                <woa-phone-number-field [(ngModel)]="identityEntityModel.data.mobilePhone" name="mobilePhone"
                                        [label]="'woa.label.common.mobile'" required
                                        woa-phone-number></woa-phone-number-field>
            }
            @if (configurationModel.captureMemberDOB()) {
                <woa-date-field [(ngModel)]="identityEntityModel.data.dob" name="dob"
                                [label]="'woa.label.common.dob'"></woa-date-field>
            }
            @if (configurationModel.loginAuthenticationMethod() === AppLoginAuthenticationMethod.PASSWORD) {
                <woa-password-field [(ngModel)]="identityEntityModel.data.password" name="password"
                                    [label]="'woa.label.common.password'" required [minlength]="'8'" [maxlength]="'20'"
                                    [autocomplete]="'new-password'"></woa-password-field>
            }
            <woa-selector-control [label]="'woa.label.common.rememberMe'"
                                  [(selected)]="remember"></woa-selector-control>
        </woa-form>
    }
    @if (mode() === IdentificationMode.VERIFY_REGISTRATION) {
        <woa-form (onSubmit)="verifyRegistration()">
            <woa-decimal-field [(ngModel)]="verificationCode" name="code"
                               [label]="'woa.label.identification.verificationCode'"
                               [autocomplete]="'one-time-code'" required [maxlength]="'50'"></woa-decimal-field>
        </woa-form>
    }
    @if (mode() === IdentificationMode.SET_PASSWORD || mode() === IdentificationMode.RESET_PASSWORD) {
        <woa-form (onSubmit)="resetPassword()">
            <woa-decimal-field [(ngModel)]="verificationCode" name="code"
                               [label]="mode() === IdentificationMode.RESET_PASSWORD ? 'woa.label.identification.resetPasswordCode' : 'woa.label.identification.setPasswordCode'"
                               [autocomplete]="'one-time-code'" required [maxlength]="'50'"></woa-decimal-field>
            <woa-password-field [(ngModel)]="identityEntityModel.data.password" name="password"
                                [label]="mode() === IdentificationMode.RESET_PASSWORD ? 'woa.label.identification.newPassword' : 'woa.label.common.password'"
                                required [minlength]="'8'" [maxlength]="'20'"
                                [autocomplete]="'new-password'"></woa-password-field>
        </woa-form>
    }
    @if (mode() !== IdentificationMode.CONFIRM) {
        <woa-button woa-page-footer-control
                    [label]="submitButtonLabel()" (onActivate)="form()?.submit()"></woa-button>
    }
    @if ((mode() === IdentificationMode.LOGIN || mode() === IdentificationMode.FORGOT_PASSWORD) && configurationModel.supportsRegistration()) {
        <woa-link id="register-now-link" woa-page-footer-control
                  [label]="'woa.label.identification.registerNow'" [link]="'woa.button.identification.registerNow'"
                  (onActivate)="mode.set(IdentificationMode.REGISTER)"></woa-link>
    }
    @if (mode() === IdentificationMode.REGISTER) {
        <woa-link id="login-link" woa-page-footer-control
                  [label]="'woa.label.identification.login'" [link]="'woa.button.identification.login'"
                  (onActivate)="mode.set(IdentificationMode.LOGIN)"></woa-link>
    }
    @if ((mode() === IdentificationMode.ENABLE_ACCOUNT) && configurationModel.supportsRegistration()) {
        <woa-link id="register-new-link" woa-page-footer-control
                  [label]="'woa.label.identification.registerNew'" [link]="'woa.button.identification.registerNew'"
                  (onActivate)="mode.set(IdentificationMode.REGISTER)"></woa-link>
    }
    @if (mode() === IdentificationMode.LOGIN && !configurationModel.supportsRegistration() && configurationModel.loginAuthenticationMethod() === AppLoginAuthenticationMethod.PASSWORD && configurationModel.supportsForgotPassword()) {
        <woa-link id="enable-link" woa-page-footer-control
                  [label]="'woa.label.identification.enable'" [link]="'woa.button.identification.enable'"
                  (onActivate)="mode.set(IdentificationMode.ENABLE_ACCOUNT)"></woa-link>
    }
    @if (mode() === IdentificationMode.VERIFY_LOGIN) {
        <woa-link id="resend-login-verification-code-link" woa-page-footer-control
                  [label]="'woa.label.identification.resendCode'" [link]="'woa.button.identification.resendCode'"
                  (onActivate)="resendLoginVerificationCode()"></woa-link>
    }
    @if (mode() === IdentificationMode.VERIFY_REGISTRATION) {
        <woa-link id="resend-registration-verification-code-link" woa-page-footer-control
                  [label]="'woa.label.identification.resendCode'" [link]="'woa.button.identification.resendCode'"
                  (onActivate)="resendRegistrationVerificationCode()"></woa-link>
    }
    @if (mode() === IdentificationMode.SET_PASSWORD || mode() === IdentificationMode.RESET_PASSWORD) {
        <woa-link id="resend-pwd-reset-code-link" woa-page-footer-control
                  [label]="'woa.label.identification.resendCode'" [link]="'woa.button.identification.resendCode'"
                  (onActivate)="resendPasswordResetCode()"></woa-link>
    }
    @if (legalMessageSet()) {
        <woa-legal-panel slot="footer-end" [messageSet]="legalMessageSet()"></woa-legal-panel>
    }
</woa-modal-page-layout>
